<template>
  <component :is="menuButtonComponent" v-if="activeHoliday && menuButtonComponent && animationEnabled" />
</template>

<script>
export default {
  computed: {
    activeHoliday() {
      return this.$holiday?.getActive()
    },
    animationEnabled() {
      return this.activeHoliday?.animation?.enabled
    },
    menuButtonComponent() {
      if (!this.activeHoliday?.animation?.menuButton?.component) {
        return null
      }

      // Dynamically import the menu button component based on holiday ID
      const holidayId = this.activeHoliday.id

      try {
        return () => import(`@/components/holiday/${holidayId}/Button.vue`)
      } catch (error) {
        console.warn(`Holiday menu button component not found for: ${holidayId}`, error)
        return null
      }
    },
  },
}
</script>
